<script>
export default {
  props: {
    tenant: { type: Object, required: true },
  },

  filters: {
    snakeToTitleCase(str) {
      if (!str) return str;
      return str.replace('_', ' ').replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
  },
}
</script>

<template>
  <b-card>
    <h4 class="mb-0 text-center"> <strong>{{tenant.name | snakeToTitleCase}}</strong> </h4>
    <div class="small text-muted text-center">your tenant name</div>
  </b-card>
</template>



// WEBPACK FOOTER //
// src/tenant/components/TenantInfo.vue